import { createInMemoryStorageHandler, StorageHandler } from "@/lib/storage";

export interface AvatarState {
  isCaptionsVisible?: boolean;
  isMuted: boolean;
}

export type AvatarStateStorage = ReturnType<typeof buildAvatarStateStorage>;

const storageKey = (isPreview: boolean) => `pyne-avatar-state${isPreview ? `-preview` : ""}`;

export const buildAvatarStateStorage = (isPreview: boolean, storage: StorageHandler) => {
  const self = () => buildAvatarStateStorage(isPreview, storage);
  return {
    key: () => {
      return storageKey(isPreview);
    },
    get: (): AvatarState => {
      return storage.get(storageKey(isPreview), {
        isCaptionsVisible: undefined,
        isMuted: false,
      });
    },
    clear: () => {
      storage.remove(storageKey(isPreview));
    },
    set: (state: Partial<AvatarState>) => {
      storage.set(storageKey(isPreview), { ...self().get(), ...state });
    },
  };
};

export const buildInMemoryAvatarStateStorage = () => buildAvatarStateStorage(false, createInMemoryStorageHandler());
